/* global gv */

/**
 * HP slider
 */
class ContactForm {

  constructor() {
    this.$form = $('#contact-form');
    this.$required = this.$form.find('[data-validate]');
    this.$successMessage = this.$form.find('.success-message');
    this.focusing = false;
    this.sending = false;

    this.recaptchaVisible = false;
  }

  static hideErrorMessage($input) {
    $input.next('.form-control-error-message').addClass('d-none');
  }

  static showErrorMessage($input) {
    $input.next('.form-control-error-message').removeClass('d-none');
  }

  validate($input, focusDelay = 200) {
    let valid = false;

    switch ($input.data('validate')) {
      case "email":
        valid = Validator.email(String($input.val()));
        break;
      case "empty":
        valid = Validator.empty($input.val());
        break;
      case "checked":
        valid = $input.prop('checked');
        break;
    }

    if (valid) {
      ContactForm.hideErrorMessage($input);
    } else {
      ContactForm.showErrorMessage($input);

      if (!this.focusing) {
        this.focusing = true;
        this.focus($input, focusDelay);
      }
    }

    return valid;
  }

  focus($input, delay = 200) {
    setTimeout(() => {
      $input[0].focus();
      this.focusing = false;
    }, delay)
  }

  validateAll() {
    let valid = [];
    let _this = this;
    this.$required.each(function () {
      valid.push(_this.validate($(this)));
    });
    return valid.indexOf(false) === -1;
  }

  resetForms() {
    this.$form[0].reset();
    this.$form.find('.form-control-error-message').addClass('d-none');
    this.$form.find('.cnt-other-collapse').collapse('hide');
  }

  showSuccessMessage() {
    this.$successMessage.fadeIn();
    //$hb.stop().animate({scrollTop: this.$form.offset().top - 200}, 500);
    /*
    setTimeout(() => {
      this.$successMessage.slideUp();
    }, 5000)
    */
  }

  captcha() {
    this.$form.append('<input name="m02403fbrp__3" type="hidden" value="true">');
  }

  send() {
    this.sending = true;

    $.post('/api/contact-form/', this.$form.serializeArray()).done((data) => {
      if (typeof data === "object") {
        this.pushEventToDataLayer(data);
        this.resetForms();
        this.showSuccessMessage();
      } else {
        alert('Error: Něco se pokazlo, zkuste to později.')
      }
      this.sending = false;
    });
  }

  hearAboutOther(action, val='') {
    switch (action) {
      case 'init':
        this.$form.find('#cnt-hear-about').on('change', (e, el) => {
          this.hearAboutOther('collapse', e.target.value)
        });
        break;
      case 'collapse':
        if (val === '19') {
          this.$form.find('.cnt-other-collapse').collapse('show');
          this.$form.find('#cnt-other').select().focus();
        } else {
          this.$form.find('.cnt-other-collapse').collapse('hide');
        }
        break;
    }
  }

  pushEventToDataLayer(data) {
    dataLayer.push({'event': 'formSent', 'formName': 'contactForm'});
    if (typeof data.crmUserId !== "undefined") {
      dataLayer.push({
        'event': 'sendCrmUserId',
        'crmUserId': data.crmUserId
      });
    }
  }

  init() {
    this.captcha();

    this.$form.on('submit', (e) => {
      e.preventDefault();
      if (this.validateAll() && !this.sending && grecaptcha.getResponse(widgetId1).length !== 0) this.send()
    });

    this.hearAboutOther('init');

    return this;
  }
}

$(".btn-contact-us-close").click(function(){
  $(".btn-contact-us").fadeOut();
  $(this).fadeOut();
});

$(".btn-close").click(function(){
  $(".success-message-modal").fadeOut("show");
});

$("form input").click(function() {
  $("#contact-form-recaptcha-container").collapse("show");
});

function setCookie(cname,cvalue,exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function checkCookie() {
    let user = getCookie("cookieBar");
    let bar = document.getElementById("cookies-oaks");

    if (user !== "") {
        bar.style.display = "none";
    } else {
        user = bar.style.display = "block";
        bar.classList.add("active");

        if (user !== "" && user != null) {
            $(bar).find(".btn-cookies, .btn-close").on('click', (e) => {
                e.preventDefault();
                bar.classList.remove("active");
                setCookie("cookieBar", user, 30);
            });
        }
    }
}

/* global gv */

/**
 * HP slider
 */
class FooterForm {

    constructor() {
        this.$formEmail = $('#footer-form-email');
        this.$form = $('#footer-form');

        this.$formEmailInput = this.$formEmail.find('#ftre-email');

        this.$inputEmail = this.$form.find('#ftr-email');
        this.$inputName = this.$form.find('#ftr-given-name');
        this.$inputSurname = this.$form.find('#ftr-family-name');
        this.$successModal = $('#footer-form-modal-success');

        this.focusing = false;
        this.sending = false;
    }

    initLightSlider()
    {
        this.$cnt.lightSlider({
            item:1,
            loop:true,
            slideMove:1,
            easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
            speed: 1200,
            pause: 3200,
            slideMargin: 0,
            auto: true,
            controls: false,
        });
    }

    static hideErrorMessage($input)
    {
        $input.next('.form-control-error-message').addClass('d-none');
    }

    static showErrorMessage($input)
    {
        $input.next('.form-control-error-message').removeClass('d-none');
    }

    validate($input, focusDelay=200)
    {
        let valid = false;

        switch($input.data('validate')) {
            case "email":
                valid = Validator.email(String($input.val()).toLowerCase());
                break;
            case "empty":
                valid = Validator.empty($input.val());
                break;
        }

        if (valid) {
            FooterForm.hideErrorMessage($input);
        } else {
            FooterForm.showErrorMessage($input);
            if (!this.focusing) {
                this.focusing = true;
                this.focus($input, focusDelay);
            }
        }

        return valid;
    }

    focus($input, delay=200)
    {
        setTimeout(() => {
            $input[0].focus();
            this.focusing = false;
        }, delay)
    }

    validateAll()
    {
        let valid = [];
        valid.push(this.validate(this.$inputEmail));
        valid.push(this.validate(this.$inputName));
        valid.push(this.validate(this.$inputSurname));

        return valid.indexOf(false) === -1;
    }

    resetForms()
    {
        this.$form[0].reset();
        this.$formEmail[0].reset();
        this.$form.find('.form-control-error-message').addClass('d-none')
    }

    fillEmail()
    {
        this.$inputEmail.val(this.$formEmailInput.val());
        if (this.validate(this.$inputEmail, 800)) {
            this.focus(this.$inputName, 800)
        }
    }

    toggleModal(action)
    {
        $('#footer-form-modal').modal(action);
    }

    showSuccessMessage() {
        this.$successModal.modal('show');
    }

    captcha() {
        this.$form.append('<input name="md5d13fbrp__14" type="hidden" value="true">');
    }

    send()
    {
        this.sending = true;

        $.post('/api/footer-form/', this.$form.serializeArray()).done((data) => {
            if (typeof data === "object") {
                this.pushEventToDataLayer(data);
                this.showSuccessMessage();
                this.resetForms();
                this.toggleModal('hide');
            } else {
                alert('Error: Něco se pokazlo, zkuste to později.')
            }
            this.sending = false;
        });
    }

    pushEventToDataLayer(data) {
        dataLayer.push({'event': 'formSent', 'formName': 'newsletterForm'});
        if (typeof data.crmUserId !== "undefined") {
            dataLayer.push({
                'event': 'sendCrmUserId',
                'crmUserId': data.crmUserId
            });
        }
    }

    init()
    {
        this.captcha();

        this.$formEmail.on('submit', (e) => {
            e.preventDefault();

            if (Validator.email(this.$formEmailInput.val())) {
                this.fillEmail();
                this.toggleModal('show');
                FooterForm.hideErrorMessage(this.$formEmailInput);
            } else {
                FooterForm.showErrorMessage(this.$formEmailInput);
            }
        });

        this.$form.on('submit', (e) => {
            e.preventDefault();
            if (this.validateAll() && !this.sending && grecaptcha.getResponse(widgetId1).length !== 0) this.send()
        });

        return this;
    }
}

$("form input").click(function() {

});

/**
 * Instagram API
 */

class InstaFeed {
  constructor() {
    this.$btn = $(".ajax-load-instafeed");
    this.$wrapper = $("#instafeed-wrapper");

    this.url = gv.root_url + '/ajax/instagram';

    this.feed = {};
    this.feedCount = 0;
    this.maxCount = 18;
  }

  static getFeedTemplate(feed) {
    let image = '';
    if (feed.thumbnail_url) {
      image = feed.thumbnail_url;
    } else {
      image = feed.media_url;
    }
    return `<div class="col-lg-4 s-mb-30"><a href="${feed.permalink}" target="_blank" class="img-squared" style="background-image: url(${image})"></a></div>`;
  }

  setFeed() {
    let htmlFeed = '';

    for (let i = 0; i < 3; i++) {
      htmlFeed += InstaFeed.getFeedTemplate(this.feed.data[this.feedCount]);
      this.feedCount++;
    }

    if (this.feedCount === this.maxCount) this.$btn.text('See more on Instagram');

    this.$wrapper.append(htmlFeed);
  }

  getFeed() {
    $.ajax({
      url: this.url,
      dataType: 'json',
      type: 'GET',
      data: {},
      success: (data) => {
        console.log(data);
        // this.url = data.pagination.next_url;
        this.feed = data;
        this.setFeed();
      },
      error: (data) => {
        console.log(data)
      }
    });
  }

  init() {
    this.getFeed();

    this.$btn.on('click', (e) => {
      if (this.feedCount < this.maxCount) {
        e.preventDefault();
        this.setFeed();
      }
    });

    return this;
  }
}


//
// var feedCounter = 3;
// var prevFeedCount = 0;
// var results = [];
//
// $(".ajax-load-instafeed").on('click', function (e) {
//   if (prevFeedCount === 0) {
//     prevFeedCount = 3;
//   }
//
//   if (feedCounter === 9) {
//     feedCounter = 9;
//   } else {
//     e.preventDefault();
//
//     feedCounter += 3;
//     prevFeedCount = feedCounter - 3;
//     loadAjaxInstaFeed();
//   }
// });
//
// /**
//  * TODO: URL převést na uživatelský tag
//  */
//
// function loadAjaxInstaFeed() {
//   $.ajax({
//     url: gv.root_url + '/ajax/instagram',
//     dataType: 'json',
//     type: 'GET',
//     data: {},
//     success: function (data) {
//       // console.log(data);
//       data.data.slice(prevFeedCount, feedCounter).forEach(function (feed) {
//         $("#instafeed-wrapper").append(
//           '<div class="col-lg-4">' +
//           '<a href="' + feed.link + '" target="_blank" class="img-squared" style="background-image: url(' + feed.images.standard_resolution.url + ')"></a>' +
//           '</div>');
//       });
//     },
//     error: function (data) {
//       console.log(data); // send the error notifications to console
//     }
//   });
// }

var gmap;

function initGoogleMap() {
  if (document.getElementById('map')) gmap = new GoogleMapController().init();
}

class GoogleMapController {

  constructor()
  {
    this.$mapContainer = $('.map-container');
    this.containerIdName = 'map';

    this.debugCoords = true;
    this.mapInitialized = false;

    this.map = null;

    this.zoom = 11;
    this.lat = 49.943860;
    this.lng = 14.604485;

    this.styles = [{"featureType":"administrative","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.locality","elementType":"labels","stylers":[{"lightness":"-60"}]},{"featureType":"administrative.neighborhood","elementType":"labels","stylers":[{"lightness":"-51"},{"gamma":"1.12"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"visibility":"simplified"},{"color":"#ffffff"}]},{"featureType":"landscape.man_made","elementType":"geometry","stylers":[{"visibility":"on"},{"saturation":"72"},{"lightness":"13"},{"color":"#e6e3df"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"visibility":"off"},{"color":"#aeaeae"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"visibility":"simplified"},{"color":"#f1c26b"}]},{"featureType":"road.highway","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.highway.controlled_access","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"visibility":"simplified"},{"color":"#cdced0"},{"lightness":"-5"}]},{"featureType":"road.arterial","elementType":"labels","stylers":[{"visibility":"simplified"},{"lightness":"-25"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"visibility":"simplified"},{"color":"#cdced0"}]},{"featureType":"road.local","elementType":"labels","stylers":[{"visibility":"simplified"},{"saturation":"-100"},{"lightness":"-1"}]},{"featureType":"road.local","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit.station","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"geometry","stylers":[{"visibility":"simplified"},{"color":"#9f9689"}]},{"featureType":"water","elementType":"labels","stylers":[{"color":"#909090"},{"saturation":"-84"},{"lightness":"-39"},{"gamma":"1.07"},{"weight":"3.22"},{"visibility":"simplified"}]}];

    this.activeMarkerCategory = 'default';
    this.markersData = null;
    this.markers = [];

    return this;
  }

  initMap()
  {
    this.map = new google.maps.Map(document.getElementById(this.containerIdName), {
      center: {lat: this.lat, lng: this.lng},
      zoom: this.zoom,
      styles: this.styles
    });
  }

  getMarkersData(callBack) {
    $.get(`${gv.content_url}/files/data/map-markers.json`, (data) => {
      this.markersData = data;
      this[callBack]();
    })
  }

  initMarkers()
  {

    if (!this.markersData) return;

    this.markersData.forEach(m => {
      this.markers.push({
        options: {
          title: m[0][langIndex],
          position: {lat: m[2], lng: m[3]},
          icon: {
            url: gv.content_url + "/images/map/" + m[4].def,
            scaledSize: new google.maps.Size(m[5], m[5])
          },
        },
        defaultIcon: gv.content_url + "/images/map/" + m[4].def,
        activeIcon: gv.content_url + "/images/map/" + m[4].active,
        infoWindowData: {
          title: m[0][langIndex],
          content: m[1][langIndex],
        },
        category: m[6],
        infoWindow: null,
        marker: null
      });
    });

    this.markers.forEach(m => {
      this.makeMarker(m);
    });
  }

  makeMarker(marker)
  {
    marker.marker = new google.maps.Marker(Object.assign(marker.options, {map: this.map}));

    if (marker.infoWindowData.title !== "") {
      marker.infoWindow = new google.maps.InfoWindow({
        content: `<h3>${marker.infoWindowData.title}</h3><div>${marker.infoWindowData.content}</div>`
      });
      marker.marker.addListener('click', () => {
        this.resetMarkers();
        marker.infoWindow.open(this.map, marker.marker);
        marker.marker.setIcon(marker.activeIcon);
      });

      marker.infoWindow.addListener('closeclick', () => {
        marker.marker.setIcon(marker.defaultIcon);
      });
    }

    if (marker.category !== this.activeMarkerCategory) marker.marker.setVisible(false);
  }

  resetMarkers()
  {
    this.markers.forEach(m => {
      m.infoWindow.close();
      m.marker.setIcon(m.defaultIcon);
    })
  }

  toggleMarkersCategory(category)
  {
    let bounds = new google.maps.LatLngBounds();

    this.resetMarkers();
    this.activeMarkerCategory = category;
    this.markers.forEach(m => {
      let visible = m.category === this.activeMarkerCategory || m.category === 'default';
      m.marker.setVisible(visible);
      if (visible) bounds.extend(m.marker.getPosition());
    });

    this.map.fitBounds(bounds);
  }

  initCoordinatesDebug()
  {
    google.maps.event.addListener(this.map, 'click', function (event) {
      console.log('lat: ' + event.latLng.lat());
      console.log('lng: ' + event.latLng.lng());
      console.log('--------------------------');
    });
  }

  init()
  {
    this.initMap();
    this.getMarkersData('initMarkers');
    this.initCoordinatesDebug();

    return this;
  }

}

/* global gv */

/**
 * Main nav controller
 */
class Nav {

    constructor() {

        this.$nav = $(".nav-oaks");
        this.$navTabs = $(".mm__nav");
        this.$subnav = $(".subnav");
        this.$toggle = $(".nav-oaks__toggle, .subnav__header__close");
        this.$collapseHeaders = this.$subnav.find('[data-second-click]');
        this.$collapseContainers = this.$subnav.find('.collapse');
        this.isOpen = false;
    }

    initFixedNavbar()
    {
        this.headroom  = new Headroom(this.$nav[0], {
            offset: this.$nav[0].clientHeight,
        });

        this.headroom.init();
    }

    open()
    {
        if (this.isOpen) return;
        if (typeof homePageSlider !== 'undefined' && homePageSlider.sliders[0]) homePageSlider.sliders[0].pause();
        this.isOpen = true;
        this.$subnav.addClass('open');
        $('html').addClass('subnav-is-open');
    }

    close()
    {
        if (!this.isOpen) return;
        if (typeof homePageSlider !== 'undefined' && homePageSlider.sliders[0]) homePageSlider.sliders[0].play();
        this.isOpen = false;
        this.$subnav.removeClass('open');
        $('html').removeClass('subnav-is-open');
    }

    toggle()
    {
        if (this.isOpen) this.close();
        else this.open();
    }

    secondClickRedirect($el)
    {
        let $collapse = $($el.attr('href'));

        if (!$collapse.data('second-click-count')) {
            this.$collapseContainers.data('second-click-count', 0);
            $collapse.data('second-click-count', 1);
            this.$collapseContainers.collapse('hide');
            this.$collapseHeaders.removeClass('collapse-active');
            $el.addClass('collapse-active');
        } else {
            location.href = $el.data('second-click');
            $el.removeClass('collapse-active');
        }
    }

    init()
    {
        let _this = this;

        this.initFixedNavbar();

        this.$toggle.on('click', () => {
            this.toggle();
        });

        this.$collapseHeaders.on('click', function () {
            _this.secondClickRedirect($(this));
        });

        $(document).on('keyup', (e) => {
            if (this.isOpen && e.key && e.key === "Escape") this.toggle();
        });

        return this;
    }
}


/**
 * Inpage nav controller
 */
class InPageNav {

    constructor(offsteTop=0) {
        this.$nav = $(".nav-inpage");
        this.offsteTop = offsteTop;
    }

    initFixedNavbar()
    {
        this.headroom  = new Headroom(this.$nav[0], {
            offset: this.$nav.offset().top,
            onPin : () => {
                this.$nav.css('top', this.offsteTop+'px')
            },
            onUnpin : () => {
                this.$nav.css('top', '0px');
            },
            onTop : () => {
                this.$nav.css('top', '0px');
            },
        });

        this.headroom.init();
    }

    init()
    {
        if (this.$nav.length) this.initFixedNavbar();
        return this;
    }
}

/**
 * Close page nav after scrolling
 */
$(window).scroll(function(){
   var page_dropdown_button = $(".dropdown-nav__title");

   if (!page_dropdown_button.hasClass("collapsed")) {
       page_dropdown_button.click();
   }
});

/**
 * Close subnav after click to href element
 */
$(".subnav__list__dropdown .collapse a").click(function(){
    $(".subnav").removeClass('open');
    $('html').removeClass('subnav-is-open');
});

/* global newsPagination */

class NewsPagination {
  constructor() {
    this.$btn = $(".news-more-btn");
    this.$container = $(".news-more-container");
    this.data = newsPagination;

    this.max = this.data.pagination.length;

    this.page = 1;
  }

  loadMore() {
    this.page++;

    axios.get(`${gv.root_url}/api/news-pagination/?p=${this.page}&l=${gv.lang}`).then((res) => {
      this.$container.append(res.data);
    });

    if (this.page === this.max) this.$btn.hide()
  }

  init() {
    if (this.max) {
      this.$btn.removeClass('d-none').on('click', () => {
        this.loadMore()
      })
    }
  }
}

/* global gv */
/* player */

/**
 * HP slider
 */

 if (gv.page_alias == 'rezidence-u-parku' || 'rezidence-u-golfu' || 'rodinne-domy' || 'vily-v-zahradach' || 'vila-u-golfu-rm-pa' || 'vila-u-golfu-jpa' || 'green-court-apartments' || 'golf-view-apartments' || 'family-houses' || 'gardens-vilas' || 'golf-view-villa-rm-pa' || 'golf-view-villa-jpa' || 'park-view-apartments') {
    var loop = true 
  } else {
    var loop = false
  }
class Slider {

    constructor($cnt, opt={}) {

        this.$cnt = $cnt;
        this.sliders = [];
        this.sliderOptions = {
            item:1,
            loop,
            slideMove:1,
            easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
            pause: 4200,
            auto: true,
            speed: 1800,
            autoplayHoverPause: true,
            slideMargin: 0,
            controls: false,
            onAfterSlide: function (el, index) {
                /*
                if (index !== 0) {
                    hpSliderPlayer.pause();
                } else {
                    hpSliderPlayer.play();
                }
                */
            },
        };

        this.sliderOptions = _.merge(this.sliderOptions, opt);

        if (this.checkRequired()) {
            this.init();
        }

    }

    checkRequired() {
        return this.$cnt.length
    }

    initLightSlider()
    {
        this.$cnt.each((i,el) => {
            let slider = $(el).lightSlider(this.sliderOptions);
            this.sliders.push(slider);
        });
    }

    init()
    {
        this.initLightSlider()
        console.log("inity...");
    }
}

class VimeoPlayer {

    constructor(elId, options, placeholderElId) {

        this.elId = elId;
        this.options = options;

        if (!this.checkRequired()) return;

        this.player = new Vimeo.Player(elId, options);
        this.placeholderEl = $('.' + placeholderElId);

        this.videoWidth = 0;
        this.videoHeight = 0;

        this.setSizeTimeout = null;

        this.setSize();
    }

    checkRequired()
    {
        return !!document.getElementById(this.elId)
    }

    setSize()
    {
        let $el = $("#"+this.elId);
        let $iframe = $el.find('iframe');
        let $wrappper = $('#headerSlider');

        let $placeholder = $('.video-bg-placeholder');
        let $overlay = $('#video-bg-overlay');

        let ww = window.outerWidth;
        let wh = window.outerHeight;

        let h = $wrappper.outerHeight() + 60;
        let w = (h / 9) * 16;
        let l = (w - ww) / 2;

        if (w < ww) {
            w = ww;
            h = (w / 16) * 9;
        }

        $placeholder.height(h);
        $overlay.height(h);

        $el.height(h);
        $iframe.height(h).width(w);

        $(window).on('resize', () => {
            clearTimeout(this.setSizeTimeout);

            this.setSizeTimeout = setTimeout(() => {
                this.setSize()
            }, 800)
        });

        return this;
    }

    fadePlaceholder()
    {
        if (!this.checkRequired()) return;

        this.player.on('play', () => {
            if (!this.placeholderEl) return;
            this.placeholderEl.addClass("hide");
            this.getVideoSize();
            this.setSize();
        });

        return this;
    }

    getVideoSize()
    {
        this.player.getVideoWidth().then(val => this.videoWidth = val);
        this.player.getVideoHeight().then(val => this.videoHeight = val);
    }

    autoplay()
    {
        this.player.on('loaded', () => {
            this.fadePlaceholder();
            this.play();
        });
        return this;
    }

    play()
    {
        this.player.play();
        return this;
    }

    pause()
    {
        this.player.pause();
        return this;
    }

    stop()
    {
        this.player.stop();
        return this;
    }

    volume(vol = 100)
    {
        this.player.setVolume(vol)
    }

}

let localityVideo = new VimeoPlayer('video-full-container', {
    id: 422732759,
    loop: true,
    responsive: true,
    muted: false,
    autoplay: false,
    controls: true,
    title: false
}, 'video-bg-placeholder').fadePlaceholder();

let localityShortVideo = new VimeoPlayer('shortVideo', {
    id: 422734503,
    loop: true,
    background: true,
    responsive: true,
    muted: false,
    autoplay: true,
    title: false
}, 'video-bg-placeholder').fadePlaceholder();


$("[data-target='#video-full']").click(function(){
    localityVideo.play();
});

$("[aria-label='Close']").click(function(){
    localityVideo.pause();
    localityShortVideo.play();
});

$(".modal").click(function(e)
{
    var container = $(".modal-content");

    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        localityVideo.pause();
        localityShortVideo.play();
    }
});

/* global gv */

/**
 * Webcam
 */
class Webcam {
    constructor($el) {
        this.$el = $el;

        this.image = $el.data('webcam');
        this.title = $el.find('h4').text();

        this.available = $el.find(".flat-available").text();
        this.fullFlat = $el.find(".flat-full").text();

        this.$thumb = $el.find('img');
        this.$modalBtn = $el.find('button');

        this.modalActive = false;
        this.render = null;

        this.init();
        this.updateImage();
    }

    static $modal() {
        return $('#webcam-modal')
    }

    static $modalImage() {
        return Webcam.$modal().find('.webcam-modal__image')
    }

    static $modalTitle() {
        return Webcam.$modal().find('.webcam-modal__title')
    }

    static updateModalImage(src) {
        Webcam.$modalImage().attr('src', src)
    }

    static updateModalTitle(text) {
        Webcam.$modalTitle().text(text)
    }

    static openModal() {
        Webcam.$modal().modal('show')
    }

    static updateWeather() {
        let apiUrl = 'https://api.openweathermap.org/data/2.5/weather?lat=49.9456387&lon=14.6048675&appid=3337f4fdef9096a30a0329a64fa4e14b&units=metric';
        if (gv.cs) apiUrl += '&lang=cz';

        axios.get(apiUrl).then((res) => {

            if (res.status !== 200) return;

            let data = res.data;
            let $w = Webcam.$modal().find('.webcam-modal__weather');
            let date = new Date();
            let day = date.toLocaleString((gv.en ? 'en-US' : 'cs-CZ'), {weekday: 'long'});
            let time = "";

            time += date.getHours() < 10 ? '0'+date.getHours() : date.getHours();
            time += ':';
            time += date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes();

            $w.find('.webcam-modal__weather__temp').text(Math.round(data.main.temp));
            $w.find('.webcam-modal__weather__stat').text(data.weather[0].description);
            $w.find('.webcam-modal__weather__day').text(day);
            $w.find('.webcam-modal__weather__time').text(time);

        })
    }

    updateImage() {
        this.$thumb.attr('src', this.image);
        if (this.modalActive) Webcam.updateModalImage(this.image)
    }

    openModal() {
        this.modalActive = true;
        Webcam.updateWeather();
        Webcam.updateModalImage(this.image);
        Webcam.updateModalTitle(this.title);
        console.log(this.available);
        if (this.available === "") {
            $('#webcam-modal').find(".webcam-count-label").hide();
        } else {
            $('#webcam-modal').find(".webcam-count-label").show();
        }
        $('#webcam-modal').find(".flat-available-detail").text(this.available);
        $('#webcam-modal').find(".flat-full-detail").text(this.fullFlat);
        Webcam.openModal()
    }

    init() {
        this.render = setTimeout(() => {
            this.updateImage()
        }, 5000);

        this.$modalBtn.on('click', () => {
            this.openModal();
        })
    }
}


/**
 * Validator
 */
class Validator {

    static email(val)
    {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(val);
    }

    static empty(val)
    {
        return val !== "";
    }

    static noZero(val)
    {
        return val !== "0" || val !== 0;
    }

    static isTrue(val)
    {
        return val === true;
    }
}

const langIndex = gv.en ? 0 : 1;

let hpSliderPlayer;

/********************************************************************
 * Global Vars
 ********************************************************************/
const $w = $(window);
const $d = $(document);
const $hb = $('html, body');
const ww = $w.width();
const wh = $w.height();

/********************************************************************
 * Navigations
 ********************************************************************/
const nav = new Nav().init();
const inpageNav = new InPageNav(nav.$nav.height()).init();

/********************************************************************
 * Sliders
 ********************************************************************/
const homePageSlider = new Slider($('.slider--homepage'));
const sliderDefault = new Slider($('.slider--default'), {
  controls: true
});
var sliderLocality = new Slider($('.slider--locality'), {
  controls: true,
  auto: true,
  speed: 1800,
  nav: false
});

/********************************************************************
 * Scroll To Target
 ********************************************************************/
function scrollTo(el, targetSelector, strict) {

  let target = targetSelector;
  let delay = 0;

  if (el) {

    let $el = $(el);
    let $elParent = $el.parent();
    let elParentCollapse = $elParent.hasClass('collapse');

    target = $el.attr('href');

    if (elParentCollapse) {
      $elParent.collapse('hide');
      delay = 400
    }
  }

  setTimeout(() => {
    let to = $(target).offset().top;
    let offset = 0;

    if (!strict) {
      let $inNav = $('.nav-inpage');
      let wst = $(window).scrollTop();
      let inPageNavHeight = $inNav.length ? $inNav.height() : 0;
      offset = wst > to ? (ww > 992 ? inPageNavHeight+120 : 120) : (ww > 992 ? inPageNavHeight+120 : 70);
    }

    $hb.stop().animate({scrollTop: to - offset}, 800)
  }, delay)
}

$('.scroll-to').on('click', function (e) {
  e.preventDefault();
  scrollTo(this)
});

$(".more-content").slice(0, 3).show();
$(".load-more-content").on("click", function(e){
    e.preventDefault()
    $(".more-content:hidden").slice(0, 3).slideDown();
    if($(".more-content:hidden").length == 0) {
        $(".load-more-content").fadeOut();
    }
});

if (ww < 992) {
  if (window.location.hash) {
    setTimeout(function () {
      var aTag = $(window.location.hash);
      $("html, body").animate({
        scrollTop: $(aTag).offset().top - 110
      }, 0);
    }, 100);
  }
}

/********************************************************************
 * Footer form
 ********************************************************************/
const footerForm = new FooterForm().init();
const contactForm = new ContactForm().init();


/********************************************************************
 * Sticky.js
 ********************************************************************/
if (ww > 992) {
  setTimeout(function () {
    const sticky = new Sticky('.sticky');
  }, 2000)
}

/********************************************************************
 * Read more
 ********************************************************************/
if (ww < 992) {

  const readMoreText = gv.en ? 'Read more' : 'Číst více';
  const readLessText = gv.en ? 'Less' : 'Méně';

  $('.read-more').readmore({
    collapsedHeight: 84,
    embedCSS: true,
    moreLink: '<a href="#" class="read-more-btn">'+readMoreText+'</a>',
    lessLink: '<a href="#" class="read-more-btn less">'+readLessText+'</a>',
  });
}

/********************************************************************
 * Master Map
 ********************************************************************/
let threeMap = document.getElementById('three-map');
let threeContainer = document.getElementById('three-map__container');
let threeContent = document.getElementById('three-map__content');

if (document.getElementById('master-plan-container')) {
  let mm = new ThreeMap(threeContainer, threeContent, threeMap);
  mm.init();

  let masterPlan = new MasterPlan($("#master-plan-container"), mm);
  masterPlan.init();
}

if (document.getElementById('walking-and-cycling-container')) {
  let mm = new ThreeMap(threeContainer, threeContent, threeMap);
  if (ww < 992) mm.zooms.max = mm.width * 5;
  mm.init();

  let walkingAndCycling = new WalkingAndCycling($("#walking-and-cycling-container"), mm);
  walkingAndCycling.init();
}

/********************************************************************
 *  Instagram.js
 ********************************************************************/
if ($("#instafeed-wrapper").length) new InstaFeed().init();
// if ($("#instafeed-wrapper").length) loadAjaxInstaFeed();

/********************************************************************
 *  News pagination
 ********************************************************************/
if ($(".news-more-btn").length) new NewsPagination().init();

/********************************************************************
 *  Webcam
 ********************************************************************/
$('[data-webcam]').each(function () {
  new Webcam($(this))
});

/********************************************************************
 *  Check cookies bar
 ********************************************************************/
$(window).on('load', function () {
  checkCookie();
});

/********************************************************************
 *  Scroll after page load
 ********************************************************************/
$(window).on('load', function () {
  if (document.getElementById(location.hash.replace('#', ''))) scrollTo(false, location.hash)
});

/********************************************************************
 * Fixed locality legend
 ********************************************************************/